import http from '../shared/HttpCommon';
import { CanceledError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { IKeywordSearch } from '../shared/interfaces/IKeywordSearch';

const getMonitoring = async (loading: Dispatch<SetStateAction<boolean>>, signal: AbortSignal) => {
  try {
    loading(true);
    const { data } = await http.get('/monitoring/keywords', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const deleteMonitoredKeyword = async (monitoring_id: string) => {
  try {
    const { data } = await http.delete(`/monitoring/keywords/${monitoring_id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const startMonitoring = async (
  keywords: IKeywordSearch[],
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.post('/keywords/schedule', {
      keywords,
    });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const KeywordMonitoringService = {
  getMonitoring,
  startMonitoring,
  deleteMonitoredKeyword,
};

export default KeywordMonitoringService;
